import { fg } from '@atlassian/jira-feature-gating';

const WivSsrAttachmentsRelayProvider = {
	get(): boolean {
		return !fg('wi2_1p_attachments_resource');
	},
};

export default WivSsrAttachmentsRelayProvider;
